// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"O7-z"};